<template>
    <div class="af-apply-with-option af-apply-with-google">
        <div
            class="af-apply-with-item afu-p-5 afu-flex afu-items-center afu-justify-center afu-shadow-lg afu-rounded-btn afu-bg-white afu-cursor-pointer afu-border afu-border-solid afu-border-transparent hover:afu-border-solid hover:afu-border hover:afu-border-secondary-light"
            @click="signInGoogle"
        >
            <img
                :src="getLogo"
                alt="Apply with google"
            >
            <span
                v-if="$mq !== 'sm'"
                class="afu-text-secondary afu-text-base afu-font-semibold afu-ml-2"
            >
                Google
            </span>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import Cookie from '@/services/cookie';
    import GoogleMixin from '@/components/Social/GoogleMixin';

    export default {
        name: 'Google',

        mixins: [GoogleMixin],

        created() {
            this.is_register = true;
        },

        methods: {
            ...mapActions('me', {
                $_storeAllUserData: 'storeAllUserData',
            }),

            ...mapMutations('jobApplication', {
                $_STORE_APPLY_USER: 'STORE_USER',
            }),

            afterLogin(data) {
                const user = data.data;
                this.$_storeAllUserData(user);
                this.$_STORE_APPLY_USER({
                    email: user.email,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    contact_number: user.contact_number,
                });
                Cookie.setToken(data.access_token);
            },
        },
    };
</script>

